'use strict';

var dateFns = require('date-fns');
var parsers = require('../parsers.cjs');

const areISODatePartIntervalsOverlapping = (l, r) => {
  const innerL = {
    start: parsers.isoDatePartToDate(l.start).getTime(),
    end: dateFns.addDays(parsers.isoDatePartToDate(l.end), 1).getTime()
  };
  const innerR = {
    start: parsers.isoDatePartToDate(r.start).getTime(),
    end: dateFns.addDays(parsers.isoDatePartToDate(r.end), 1).getTime()
  };
  return dateFns.areIntervalsOverlapping(innerL, innerR);
};

module.exports = areISODatePartIntervalsOverlapping;
//# sourceMappingURL=areISODatePartIntervalsOverlapping.cjs.map
